var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-3xl mb-8"},[_vm._v("Berichte")]),_c('div',{staticClass:"shadow rounded overflow-hidden items-center"},[_c('stats-date-picker',{scopedSlots:_vm._u([{key:"default",fn:function({ dateFrom, dateTo }){return [_c('key-figures',{attrs:{"dateFrom":dateFrom,"dateTo":dateTo}})]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }